import React from 'react';
import PropTypes from 'prop-types';

const RadioBtn = ({label, name, value, option, disabled, onChange, children}) => {
  return (
    <div className="radio">
      <label>
        {children}
        <input
          type="radio"
          name={name}
          value={option}
          onChange={(e) => onChange(e.target.value)}
          checked={option === value}
          disabled={disabled}
        />{label}
      </label>
    </div>
  );
};

RadioBtn.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  name: PropTypes.string.isRequired,
  option: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  children: PropTypes.node
};

RadioBtn.defaultProps = {
  disabled: false
};

export default RadioBtn;
